import React from "react";

// Two-state switch between active and archived records.
export default function ViewToggle({ value, onChange, archivedCount }) {
  const options = [
    { key: "active", label: "Active" },
    {
      key: "archived",
      label: archivedCount ? `Archived (${archivedCount})` : "Archived",
    },
  ];
  return (
    <div className="adm-segmented" role="radiogroup" aria-label="Show records">
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          role="radio"
          aria-checked={value === opt.key}
          className="adm-segmented__option"
          onClick={() => onChange(opt.key)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
